export const eventTypes = [
  {
    id: "all",
    value: "All Events",
  },
  {
    id: "upcoming",
    value: "Upcoming Events",
  },
  {
    id: "recurring",
    value: "Recurring Events",
  },
  {
    id: "past",
    value: "Past Events",
  },
];

export const csvHeaders = [
  { label: "Invitee", key: "fullName" },
  { label: "Invitee Type", key: "isResident" },
  { label: "Email", key: "email" },
  { label: "Phone Number", key: "phone" },
  { label: "Add’l Guests", key: "additionalGuests" },
  { label: "Status", key: "status" },
];
